/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import Page from '../../components/PageWrapper';
import useUserAccount from '../../hooks/stateHooks/userAccountHook';
import { userOnboardingStages } from '../../resources/types';
import ActivateAccount from './ActivateAccount';
import { IUser } from '../../components/models/User';
import AccountActivated from './AccountActivated';
import { useNavigate } from 'react-router-dom';
import useRoute from '../../hooks/routesHook';

function UserOnboarding() {
  const { updateProfile } = useUserAccount();
  const { getDashboardBase} = useRoute();
  const [stage, setStage] = useState<userOnboardingStages>("activate-account");
  const [iUser, setIUser] = useState<IUser | null>(null);
  const navigate = useNavigate();

  const getStageComponent = () => {
    switch (stage) {
      case "activate-account":
        return <ActivateAccount
          onActivated={(iUser: IUser) => {
            setStage("go-to-dashboard");
            setIUser(iUser);
          }}
        />
      case "go-to-dashboard":
        return <AccountActivated
          onConfirm={function (): void {
            updateProfile({ ...iUser } as IUser);
            navigate(`${getDashboardBase()}/dashboard`);
          }}
          title={'Account Sucessfully Activated'}
          description={'Click continue below to access your dashboard.'}
        />
    }
  }

  return (
    <Page title="Activate account">
      <div className='flex items-center justify-center w-full min-h-screen'>
        {/* Display view for stage */}
        {getStageComponent()}
      </div>
    </Page>
  );
}

export default UserOnboarding;
